// extracted by mini-css-extract-plugin
module.exports = {"baseStoreTagList":"BaseStoreTagList_baseStoreTagList_33yVL"};